import { formatAddress } from "../../../helpers/addressHelpers";

export const searchColumns = [
  { keyName: "customerName" },
  { keyName: "customerId" },
  { keyName: "customerTypeValue" },
  { keyName: "customerAddress", formatRowData: formatAddress },
  { keyName: "customerAddress.province" },
  { keyName: "customerAddress.country" }
];

export const sortColumns = [
  { keyName: "customerName" },
  { keyName: "customerId" },
  { keyName: "customerTypeValue" },
  { keyName: "customerAddress", formatRowData: formatAddress },
  { keyName: "customerAddress.province" },
  { keyName: "customerAddress.country" }
];



// WEBPACK FOOTER //
// ./src/components/Customer/List/SearchColumns.js